import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'FAMLY_PAY_PAYMENT_SETUP';

export const {
    action: dismiss,
    success: dismissSuccess,
    failed: dismissFailed,
} = createAction(`${domain}/DISMISS`, () => ({}));
